import { render, staticRenderFns } from "./StemwijzerCta.vue?vue&type=template&id=71ee852a&scoped=true&"
import script from "./StemwijzerCta.vue?vue&type=script&lang=js&"
export * from "./StemwijzerCta.vue?vue&type=script&lang=js&"
import style0 from "./StemwijzerCta.vue?vue&type=style&index=0&id=71ee852a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ee852a",
  null
  
)

export default component.exports